export default {"src":"/_next/static/media/aboutUs3.667d6671.svg","height":1386,"width":1340};